import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';
import { ColDef } from 'ag-grid-community';
import {
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldAmountCol,
  fieldApprovedByCol,
  fieldBuildingNameCol,
  fieldConfidentialityStatusCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDistrictCol,
  fieldIdCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldNoticeOfCancellationInMonthsCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTextCol,
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';
@Injectable({
  providedIn: 'root'
})
export class LeaseIncentivesReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any; left: any; right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'repped_customer',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INCENTIVE_TYPE'),
        key: 'incentive_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DESCRIPTION'),
        key: 'description',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DATE_APPLIED'),
        key: 'date_applied',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('NO_OF_MONTHS'),
        key: 'no_of_months',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INCENTIVE_AMOUNT'),
        key: 'incentive_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },      
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },    
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },          
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },       
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },       
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },      
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },     
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      }, 
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },       
      {
        ...fieldRepresentedPartyCol,
        field: 'repped_customer',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },     
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },       
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },      
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },         
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },      
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },        
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },     
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },      
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },       
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },   
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },     
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      }, 
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },
      {
        ...fieldTextCol,
        field: 'incentive_type',
        headerName: this.translateService.getTranslation('INCENTIVE_TYPE'),
      },
      {
        ...fieldTextCol,
        field: 'description',
        headerName: this.translateService.getTranslation('DESCRIPTION'),
      },
      {
        ...fieldDateCol,
        field: 'date_applied',
        headerName: this.translateService.getTranslation('DATE_APPLIED'),
      },
      {
        ...fieldNoticeOfCancellationInMonthsCol,
        field: 'no_of_months',
        headerName: this.translateService.getTranslation('NO_OF_MONTHS'),
      },     
      {
        ...fieldAmountCol,
        field: 'incentive_amount',
        headerName: this.translateService.getTranslation('INCENTIVE_AMOUNT'),
      },   
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },     
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      }, 
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      }         
    ];
  }
}
